var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38041",
    "data-name": "Group 38041",
    transform: "translate(142 -1730)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14655",
    "data-name": "Rectangle 14655",
    width: 24,
    height: 24,
    transform: "translate(-142 1730)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "advertisement",
    transform: "translate(-140.5 1731.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33388",
    "data-name": "Path 33388",
    d: "M26.071,1.9a.636.636,0,0,0-.821.36l-.416,1.063a.634.634,0,1,0,1.181.462l.416-1.063A.633.633,0,0,0,26.071,1.9Z",
    transform: "translate(-8.096 -1.8)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33389",
    "data-name": "Path 33389",
    d: "M29.519,10.215,28.456,9.8a.634.634,0,0,0-.462,1.182l1.063.416a.634.634,0,0,0,.462-1.182Z",
    transform: "translate(-8.923 -4.135)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33390",
    "data-name": "Path 33390",
    d: "M28.2,7.031a.627.627,0,0,0,.254-.054L29.5,6.52a.634.634,0,1,0-.509-1.161l-1.046.458A.634.634,0,0,0,28.2,7.031Z",
    transform: "translate(-8.916 -2.82)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33391",
    "data-name": "Path 33391",
    d: "M15.054,4.594,14.21,2.668A1.478,1.478,0,0,0,11.584,2.5,10.72,10.72,0,0,1,6.375,6.935l0,0h0L2.925,8.445A3.048,3.048,0,0,0,1.356,12.46l.9,2.06a3.049,3.049,0,0,0,4.015,1.569l.263-.116,2.022,4.617a2.052,2.052,0,1,0,3.76-1.647l-2.013-4.6a10.615,10.615,0,0,1,6.2-.588,1.457,1.457,0,0,0,1.447-.5,1.479,1.479,0,0,0,.215-1.541l-.843-1.926a2.9,2.9,0,0,0-2.275-5.2ZM4.4,14.955a1.77,1.77,0,0,1-.983-.944l-.9-2.059a1.782,1.782,0,0,1,.917-2.345L6.3,8.354l2.33,5.321L5.764,14.927A1.779,1.779,0,0,1,4.4,14.955Zm6.767,5.1a.777.777,0,0,1-.416.433.786.786,0,0,1-1.033-.4L7.7,15.466l1.437-.629,2.022,4.617A.786.786,0,0,1,11.169,20.053Zm5.809-7.6a.188.188,0,0,1-.192.068h0a11.848,11.848,0,0,0-6.993.653L7.457,7.838a11.841,11.841,0,0,0,5.223-4.7.18.18,0,0,1,.182-.094.214.214,0,0,1,.189.13l3.961,9.047a.217.217,0,0,1-.033.227ZM15.584,5.8a1.643,1.643,0,0,1,1.53.983,1.624,1.624,0,0,1,.025,1.256,1.645,1.645,0,0,1-.34.536Z",
    transform: "translate(-1.098 -1.778)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.8eae785adc9d8028434cebb9ca64cee2.svg";
export { ForwardRef as ReactComponent };